import React from 'react';
import { MessageCircleQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';
import ScrewDriverIcon from '@/assets/icons/ScrewdriverIcon';

const MainFeatures = ({ dashboardLinkPrefix }) => {
  const features = [
    {
      title: 'Etterspør papirer',
      description: 'Ble om at en leverandør laster opp dokumenter',
      link: `${dashboardLinkPrefix}/create-mdr`,
      icon: MessageCircleQuestion,
    },
    {
      title: 'Finn håndverker',
      description: 'Finn noen dyktige til å gjøre jobben for deg',
      link: `${dashboardLinkPrefix}/more/find-professional`,
      icon: ScrewDriverIcon,
    },
  ];
  return (
    <div>
      <h3 className="text-xl font-medium mb-2">Valg</h3>
      <div className="grid grid-cols-2 gap-5">
        {features.map((el) => {
          const Icon = el.icon;
          return (
            <Link key={el.title} to={el.link}>
              <div className="flex flex-col">
                <div className="flex items-center justify-center rounded border bg-white py-[25px]">
                  <Icon />
                </div>
                <h4 className="text-base font-medium mt-2">{el.title}</h4>
                <p className="text-sm">{el.description}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MainFeatures;
